/* ==========================================================================
   mega-menu.js — Injecte les "Cartes méga menu" (section éditable)
   --------------------------------------------------------------------------
   Lit les cartes définies dans la section "Cartes méga menu"
   (#custom-mega-cards-data) et remplace, dans chaque méga menu, la LISTE DE
   PRODUITS (.mega-menu__content) par une grille de cartes image + texte.
   Matching : le champ "Menu" de la carte = titre du lien du header
   (.menu-list__link-title). 3 cartes max par menu.

   Robustesse : le thème peut ré-afficher sa liste de produits d'origine
   (navigation, morphing, rendu tardif). On vérifie donc que NOTRE grille est
   bien présente et correspond au bon menu ; sinon on réinjecte tout de suite.

   À CHARGER dans theme.liquid :
     <script src="{{ 'mega-menu.js' | asset_url }}" defer></script>
   ========================================================================== */
(function () {
  'use strict';

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  /* lit les cartes de la section cachée */
  function readCards() {
    var host = document.getElementById('custom-mega-cards-data');
    if (!host) return [];
    return Array.prototype.map.call(host.querySelectorAll('.cmc-card-data'), function (d) {
      return {
        menu: norm(d.getAttribute('data-menu')),
        heading: d.getAttribute('data-heading') || '',
        sub: d.getAttribute('data-sub') || '',
        link: d.getAttribute('data-link') || '',
        linkText: d.getAttribute('data-link-text') || '',
        img: d.getAttribute('data-img') || '',
        alt: d.getAttribute('data-img-alt') || ''
      };
    }).filter(function (c) { return c.menu; });
  }

  function cardHTML(c) {
    var img = c.img
      ? '<span class="cmc-card__media"><img class="cmc-card__img" src="' + esc(c.img) + '" alt="' + esc(c.alt) + '" loading="lazy"></span>'
      : '<span class="cmc-card__media"></span>';
    var h = c.heading ? '<p class="cmc-card__heading">' + esc(c.heading) + '</p>' : '';
    var s = c.sub ? '<p class="cmc-card__sub">' + esc(c.sub) + '</p>' : '';
    var cta = c.linkText ? '<span class="cmc-card__cta">' + esc(c.linkText) + '</span>' : '';
    var inner = img + '<span class="cmc-card__text">' + h + s + cta + '</span>';
    if (c.link) return '<a class="cmc-card" href="' + esc(c.link) + '">' + inner + '</a>';
    return '<span class="cmc-card">' + inner + '</span>';
  }

  function gridHTML(cards) {
    return '<div class="cmc-grid" style="--cmc-cols:' + cards.length + '">' +
      cards.map(cardHTML).join('') + '</div>';
  }

  function sigOf(cards) {
    return cards.map(function (c) {
      return c.img + '¦' + c.heading + '¦' + c.sub + '¦' + c.link + '¦' + c.linkText;
    }).join('||');
  }

  function apply() {
    var cards = readCards();
    if (!cards.length) return;

    document.querySelectorAll('.menu-list__list-item').forEach(function (item) {
      var titleEl = item.querySelector('.menu-list__link-title');
      var title = titleEl ? norm(titleEl.textContent) : '';
      if (!title) return;

      // les cartes de CE menu précis (matché par le titre)
      var mine = cards.filter(function (c) { return c.menu === title; }).slice(0, 3);
      if (!mine.length) return;

      var submenu = item.querySelector('.menu-list__submenu');
      if (!submenu) return;
      var target = submenu.querySelector('.mega-menu__content') ||
                   submenu.querySelector('.mega-menu');
      if (!target) return;

      var sig = sigOf(mine);
      var grid = target.querySelector(':scope > .cmc-grid');

      // Déjà bon UNIQUEMENT si la grille existe ET correspond à ce menu.
      // (Si le thème a réaffiché ses produits, grid est nul -> on réinjecte.)
      if (grid && target.getAttribute('data-cmc-sig') === sig) return;

      target.setAttribute('data-cmc-sig', sig);
      target.innerHTML = gridHTML(mine);
    });
  }

  /* ---- déclencheurs ------------------------------------------------------ */

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 30); }

  // 1) au chargement
  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);

  // 2) le thème modifie le DOM (navigation / morphing / rendu tardif) ->
  //    on réinjecte très vite si nos cartes ont été effacées.
  //    On observe UNIQUEMENT le header (pas toute la page) : ça évite des
  //    dizaines de déclenchements inutiles pendant le chargement du contenu.
  var moRoot = document.getElementById('header-group') ||
               document.querySelector('header-component') ||
               document.body;
  new MutationObserver(schedule).observe(moRoot, { childList: true, subtree: true });

  // 3) filet immédiat : dès qu'on survole / ouvre un menu, on garantit les
  //    cartes AVANT que le panneau ne soit visible (apply est idempotent :
  //    il ne refait rien si tout est déjà bon)
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.menu-list__list-item, .header-menu')) apply();
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.menu-list__list-item, .header-menu')) apply();
  });

  // 4) édition dans l'éditeur de thème -> on force un rafraîchissement complet
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-cmc-sig]').forEach(function (el) {
      el.removeAttribute('data-cmc-sig');
    });
    schedule();
  });

  // 5) drapeau "prêt" : on n'active les animations d'ouverture du méga menu
  //    qu'une fois la page stabilisée (évite le glitch des premières secondes).
  //    Avant ça, le CSS coupe les transitions (ouverture instantanée, propre).
  function markReady() { document.documentElement.classList.add('mega-anim-ready'); }
  if (document.readyState === 'complete') setTimeout(markReady, 700);
  else window.addEventListener('load', function () { setTimeout(markReady, 700); });
})();